import {
	ItemTypeDetailModal,
	type ItemTypeDetailModalProps,
} from "../ItemTypeDetailModal";

export type SkillDetailDialogProps = ItemTypeDetailModalProps;

export const SkillDetailDialog = (props: SkillDetailDialogProps) => (
	<ItemTypeDetailModal showLevelLabels {...props} />
);
